/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesGet } from "../../funcs/workspacesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiWorkspaceServiceV1WorkspacesIdRequest$inboundSchema,
};

export const tool$workspacesGet: ToolDefinition<typeof args> = {
  name: "workspaces_get",
  description: `Get workspace details`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
